import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { axiosInstance } from '../../../helpers'
import { Company, CompanyStatus } from '../../../models'
import { CompanyWithInvoiceCode } from '../Property/types'
import { ADMIN_VENDORS_LIST_KEY } from './useAdminVendorsList'

export const useVendors = () => {
    const queryClient = useQueryClient()

    const invalidateVendorList = useCallback(() => {
        queryClient.invalidateQueries({ queryKey: [ADMIN_VENDORS_LIST_KEY] })
    }, [queryClient])

    const getVendorApartmentList = async (vendorId: number) => {
        const response = await axiosInstance.get<Company[]>(
            `/account-manager/vendors/${vendorId}/get-vendor-apartments/`,
        )
        return response.data
    }

    const addVendorToPremium = async (vendorId: number) => {
        const { data } = await axiosInstance.post<CompanyWithInvoiceCode>(
            `/account-manager/vendors/${vendorId}/add-to-premium-plan/`,
            {},
        )
        invalidateVendorList()
        return data
    }

    const removeVendorFromPremium = async (vendorId: number) => {
        const { data } = await axiosInstance.post<
            CompanyWithInvoiceCode | { message: string }
        >(`/account-manager/vendors/${vendorId}/remove-from-premium-plan/`)
        invalidateVendorList()
        return data as CompanyWithInvoiceCode
    }

    const updateVendorStatus = async (
        vendorId: number,
        status: CompanyStatus,
    ) => {
        const { data } = await axiosInstance.patch<CompanyWithInvoiceCode>(
            `/account-manager/vendors/${vendorId}/`,
            { status },
        )
        invalidateVendorList()
        return data
    }

    return {
        getVendorApartmentList,
        addVendorToPremium,
        removeVendorFromPremium,
        updateVendorStatus,
    }
}
